import { z } from "zod";

const integerSchema = z.number().int().positive().nullable().optional();

const dailyWorkingHoursSchema = z
  .string()
  .regex(/^\d{1,2}([,.]\d{1,2})?$/, "Niepoprawny format liczby")
  .transform((val) => parseFloat(val.replace(",", ".")))
  .refine((val) => val >= 0.01 && val <= 24, {
    message: "Należy wprowadzić wartość liczbową w zakresie 0,01-24,00",
  });

const baseSchema = z
  .object({
    workingHoursFractionNominator: integerSchema,
    workingHoursFractionDenominator: integerSchema,
    dailyWorkingHours: dailyWorkingHoursSchema,
  })
  .passthrough();

export const EmployeeFormSchema = baseSchema.superRefine((data, ctx) => {
  const { workingHoursFractionNominator, workingHoursFractionDenominator } =
    data;

  if (
    (workingHoursFractionNominator != null &&
      workingHoursFractionDenominator == null) ||
    (workingHoursFractionNominator == null &&
      workingHoursFractionDenominator != null)
  ) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message:
        "Oba pola muszą być wypełnione lub pozostać puste",
      path: ["workingHoursFraction"],
    });
  }

  if (
    workingHoursFractionNominator != null &&
    workingHoursFractionDenominator != null &&
    (workingHoursFractionNominator <= 0 || workingHoursFractionDenominator <= 0)
  ) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Wartości w obu polach muszą być większe od 0",
      path: ["workingHoursFraction"],
    });
  }
});
